module.exports = __webpack_public_path__ + "img/__icon_PLATFORMA.3a156e92.svg";